import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { alertActions, specProgReqActions } from '_actions';
import {
    PatientDot,
    PatientCareCenterButton,
    LoadingIcon,
    ReplyButton,
    SaveButton,
    CancelButton
} from '_components'
import messageCenterCommonStyles from 'MessageCenter/Common.module.css'
import styles from './Details.module.css'
import { getDateMDYYYY } from '_helpers';

class PeerReviewSpecialProgDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            replyMsg: ''
        };
    }

    handleChange(event) {
        this.setState({ replyMsg: event.target.value });
    }

    reply() {
        if (this.state.replyMsg.trim() !== '') {
            this.props.reply(this.props.message.nosxno, this.state.replyMsg, this.props.message.urno);
            this.setState({ replyMsg: '' });
        } else {
            this.props.alertWarning('You must supply a message to reply with.');   
        }
    }

    render() {
        if (this.props.message)
            return (
                <div className={messageCenterCommonStyles.message_center_details_wrapper} >
                    <div className={messageCenterCommonStyles.message_header}>Peer Review - Special Prog: {this.props.message.ptname}</div>
                    <hr className={messageCenterCommonStyles.message_header_separator} />

                    <div className={styles.details_table}>
                        <div className={styles.details_cell} >
                            <div className={styles.labels}>
                                <div>Patient:</div>
                                <div>Date of Request:</div>
                                <div>Clinic:</div>
                                <div>Payer:</div>
                                <div>Employer:</div>
                                <div>Type:</div>
                                <div>Status:</div>
                            </div>
                            <div className={styles.data}>
                                <div className={this.props.message.isFederal ? styles.italic : ''}>
                                    <span className={styles.patient_dot}><PatientDot id={this.props.message.dot} /></span>
                                    {' ' + this.props.message.ptname + ' (SYS#' + this.props.message.ptno + ')'}
                                </div>
                                <div>{getDateMDYYYY(this.props.message.requestDate)}</div>
                                <div>{this.props.message.locationName}</div>
                                <div>{this.props.message.payerName}</div>
                                <div>{this.props.message.employerName}</div>
                                <div>{this.props.message.requestType}</div>
                                <div>{this.props.message.status}</div>
                            </div>
                        </div>
                        <div className={styles.button_wrapper}>
                            <div className={styles.button_div}>
                                <span className={styles.button}><ReplyButton onClick={() => this.props.toggleReply()} /></span>
                                <span className={styles.button}><PatientCareCenterButton ptno={this.props.message.ptno} /></span>
                            </div>
                        </div>
                    </div>

                    {this.props.replyVisible &&
                        <div className={styles.reply_wrapper}>
                            <div className={styles.reply_header}>Reply</div>
                            <div className={styles.reply_body} >
                                <div className={styles.reply_text_area_wrapper} >
                                    <textarea maxLength={3000} autoFocus name="replyMsg" type="text" className={styles.reply_text_area} rows="4" value={this.state.replyMsg} onChange={e => this.handleChange(e)} />
                                </div>
                                <div className={styles.reply_buttons_wrapper} >
                                    <div className={styles.reply_buttons_block} >
                                        <span className={styles.button} ><SaveButton onClick={() => this.reply()} /></span>
                                        <span className={styles.button} ><CancelButton onClick={() => this.props.toggleReply()} /></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    <div className={styles.wrapper}>
                        {this.props.messageHistory && this.props.messageHistory.length > 0 ? Object.keys(this.props.messageHistory)
                            .map(key => {
                                const historyEntry = this.props.messageHistory[key];
                                return <div key={historyEntry.mgno} className={styles.message_wrapper} >
                                    <div className={styles.message_header} >{new Date(historyEntry.addDate).toLocaleString("en-US") + " - Message by " + historyEntry.addUser}</div>
                                    <div className={styles.message_content} >{historyEntry.message}</div>
                                </div>
                            }) : <span />
                        }
                    </div>


                </div>
            );
        else
            return (
                <div className={messageCenterCommonStyles.message_center_details_wrapper} >
                    <div className={messageCenterCommonStyles.message_header}>Peer Review - Special Prog</div>
                    <hr className={messageCenterCommonStyles.message_header_separator} />
                    {this.props.loading === true ?
                        <LoadingIcon size="small" />
                        : <div className={styles.italic}>No Message Selected</div>
                    }
                </div>
            );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleReply: bindActionCreators(specProgReqActions.toggleReply, dispatch),
        reply: bindActionCreators(specProgReqActions.reply, dispatch),
        alertWarning: bindActionCreators(alertActions.warningMsg, dispatch)
    };
}

function mapStateToProps(state) {
    let message = state.entities.specProgReqMsgs[state.ui.specProgReqMsgs.selectedMessage];
    let messageHistory = message ? Object.keys(state.entities.specProgReqMsgDetails)
        .filter(key => { return state.entities.specProgReqMsgDetails[key].mgsxno === message.nosxno; })
        .sort((a, b) => new Date(state.entities.specProgReqMsgDetails[b].addDate) - new Date(state.entities.specProgReqMsgDetails[a].addDate))
        .map(key => state.entities.specProgReqMsgDetails[key])
        : undefined;

    return {
        message,
        loading: state.ui.specProgReqMsgs.loading,
        messageHistory,
        replyVisible: state.ui.specProgReqMsgs.replyVisible
    };
}


const connectedPeerReviewSpecialProgDetails = connect(mapStateToProps, mapDispatchToProps)(PeerReviewSpecialProgDetails);
export { connectedPeerReviewSpecialProgDetails as PeerReviewSpecialProgDetails };
